<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box">
      <div class="coupon_content">
        <div class="menu_list">
          <div class="cart_text">购物车</div>
        </div>
        <div class="content" v-if="orderList.length">
          <div class="order_list">
            <div class="flex Flexalign order_top FlexBetween">
              <div class="order_info">商品信息</div>
              <div class="order_organization">机构</div>
              <div class="order_price">金额</div>
              <div class="order_action">操作</div>
            </div>
            <div class="flex Flexalign order_top FlexBetween order_one" v-for="(item, index) in orderList" :key="index"
              :class="[index % 2 == 0 ? 'active_order_one' : '']">
              <div class="order_info order_img flex Flexalign">
                <div class="selected_box">
                  <el-checkbox v-model="item.selected" size="large" @click="changeSelected" />
                </div>
                <el-image class="video_img" :src="imgPath(item.courseInfo?.courseCoverImg)"></el-image>
                <div class="order_empty order_name toverflows toverflow2">
                  {{ item.courseInfo?.courseName }}
                  <!-- 显示选中的规格信息 -->
                  <div class="spec_info" v-if="item.spec && Object.keys(item.spec).length">
                    <span v-for="(value, key, idx) in item.spec" :key="idx">
                      {{ key }}：{{ value }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="order_organization toverflow">
                {{ item.courseInfo?.shopName }}
              </div>
              <div class="order_price order_price_value">
                ￥<span class="price_num">{{ getDisplayPrice(item) }}</span>
              </div>
              <div class="order_action action_btn flex Flexalign flexcolumn FlexAround">
                <div class="car_btn buy_btn cursor_pointer" @click="buyNow(item)">
                  立即购买
                </div>
                <div class="car_btn add_btn cursor_pointer" @click="addColect(item.courseId)" v-if="!item.isCollected">
                  加入收藏
                </div>
                <div class="car_btn add_btn cursor_pointer" @click="removeCar(item.cartId)">
                  删除
                </div>
              </div>
            </div>
          </div>
          <div class="flex FlexBetween Flexalign check_all_box mar_top_20">
            <div class="check_all flex Flexalign">
              <div class="selected_box">
                <el-checkbox v-model="selectedAll" size="large" />
              </div>
              <div class="select_all_text">全选</div>
              <div class="split_line"></div>
              <div class="select_all_text cursor_pointer" @click="removeCar(null)">
                删除所选商品
              </div>
            </div>
            <div class="selected_info flex Flexalign">
              <div class="selected_num">
                已选
                <span class="selected_num_value">{{ selectedNum }}</span> 件商品
              </div>
              <div class="total_price_text">总计金额：</div>
              <div class="total_price selected_num_value flex Flexalign">
                ￥<span class="selected_num_value total_price_value">{{
                  selectedPrice
                }}</span>
              </div>
            </div>
          </div>
          <div class="flex FlexjustifyEnd mar_top_20">
            <div class="btn_pay cursor_pointer" @click="goPay">去支付</div>
          </div>
        </div>
        <div class="empty_box" v-else>
          <el-image class="car_empty_bg_img" :src="imgPath('car_empty_bg_img.png')"></el-image>
          <div class="empty_text">购物车空空如也～马上开始学习</div>
          <div class="cursor_pointer btn" @click="href('/courseList')">去选课</div>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
export default {
  name: "GjkcH5Cart",

  components: {},
  data() {
    return {
      orderList: [],
      selectedAll: false,
      selectedNum: 0,
      selectedPrice: 0,
      carOrderInfo: {
        cartList: [],
        pointsNum: 0,
      },
      loading: {},
      collectList: []
    };
  },
  watch: {
    selectedAll: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
        if (newValue) {
          this.orderList.forEach((item) => {
            item.selected = true;
          });
        } else {
          let indexSelected = this.orderList.findIndex((item) => item.selected != true);
          if (indexSelected == -1) {
            this.orderList.forEach((item) => {
              item.selected = false;
            });
          }
        }
        this.calculatePrice();
      },
    },
  },

  created() {
    this.getCollectCourseList();
  },

  methods: {
    /**
 * 获取商品显示价格
 * @param {Object} item 购物车商品项
 * @returns {Number} 价格
 */
    getDisplayPrice(item) {
      // 如果有多规格配置且规格不为空
      if (item.courseInfo?.styleSettingMode == 2 && item.spec && Object.keys(item.spec).length) {
        try {
          // 解析规格配置
          const specConfig = typeof item.courseInfo.specConfig === 'string'
            ? JSON.parse(item.courseInfo.specConfig)
            : item.courseInfo.specConfig;

          const skuList = specConfig.skuList || [];

          // 获取当前商品的规格
          const currentSpec = item.spec;

          // 查找完全匹配的 SKU
          const matchedSku = skuList.find(sku => {
            const skuSpec = sku.spec;

            // 检查规格数量是否一致
            const specKeys = Object.keys(currentSpec);
            const skuSpecKeys = Object.keys(skuSpec);

            if (specKeys.length !== skuSpecKeys.length) {
              return false;
            }

            // 检查每个规格属性是否匹配
            return specKeys.every(key => skuSpec[key] === currentSpec[key]);
          });

          // 如果找到匹配的 SKU，返回其价格
          if (matchedSku && typeof matchedSku.price !== 'undefined') {
            console.log('匹配到规格价格:', matchedSku.price, '规格:', currentSpec);
            return matchedSku.price;
          }

          // 如果没有匹配的 SKU，使用原价格
          console.warn('未找到匹配的规格，使用原价格:', item.coursePrice);
          return item.coursePrice || item.courseInfo?.coursePrice || 0;

        } catch (error) {
          console.error('解析规格配置失败:', error, item.courseInfo?.specConfig);
          return item.coursePrice || item.courseInfo?.coursePrice || 0;
        }
      }

      // 单规格情况，直接返回课程价格
      return item.coursePrice || item.courseInfo?.coursePrice || 0;
    },

    /**
     * 获取商品价格（用于计算，返回数字类型）
     * @param {Object} item 购物车商品项
     * @returns {Number} 价格数字
     */
    getPriceNumber(item) {
      const price = this.getDisplayPrice(item);
      return typeof price === 'number' ? price : parseFloat(price) || 0;
    },

    // 获取收藏列表
    getCollectCourseList() {
      this.$Api.course.getCollectCourseList(this.listQuery).then((res) => {
        this.collectList = res.data.data.list;
        this.getCarList();
      }).catch(err => {
        console.log(err)
      });
    },

    // 单选
    changeSelected() {
      setTimeout(() => {
        let isAllSelected = true;
        this.orderList.forEach((item) => {
          if (!item.selected) {
            isAllSelected = false;
          }
        });
        isAllSelected ? (this.selectedAll = true) : (this.selectedAll = false);
        this.calculatePrice();
      }, 500);
    },

    // 计算选中价格以及数量等
    calculatePrice() {
      this.selectedNum = 0;
      this.selectedPrice = 0;
      this.orderList.forEach((item) => {
        if (item.selected) {
          this.selectedNum++;
          this.selectedPrice += this.getPriceNumber(item);
        }
      });
      // 保留两位小数
      this.selectedPrice = this.selectedPrice.toFixed(2);
    },

    // 获取购物车列表
    getCarList() {
      this.$Api.shop
        .getCarList({ type: 1 })
        .then((res) => {
          this.orderList = res.data.data.map((item) => {
            let selected = false;
            let isCollected = false;
            console.log(this.collectList)
            let currentIndex = this.collectList.findIndex(sitem => sitem?.courseInfo?.courseId == item.courseId);
            if (currentIndex != -1) {
              isCollected = true;
            } else {
              isCollected = false;
            }

            // 处理规格数据
            let spec = {};
            if (item.spec && typeof item.spec === 'string') {
              try {
                spec = JSON.parse(item.spec);
              } catch (e) {
                console.error('解析规格数据失败:', e);
                spec = {};
              }
            } else if (item.spec && typeof item.spec === 'object') {
              spec = item.spec;
            }

            // 获取显示价格
            const displayPrice = this.getDisplayPrice({ ...item, spec });

            console.log({ ...item, selected, isCollected, spec, displayPrice })
            return { ...item, selected, isCollected, spec };
          });
          this.changeSelected();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 移除购物车
    removeCar(id) {
      let ids = "";
      if (!id) {
        this.orderList.forEach((item) => {
          if (item.selected) {
            item.selected = false;
            ids += item.cartId + ",";
          }
        });
        ids = ids.slice(0, ids.length - 1);
      } else {
        ids = id;
      }
      this.$Api.shop
        .removeCar(ids)
        .then((res) => {
          console.log(res);
          this.$Dialog.toast("删除成功");
          this.getCarList();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 加入收藏
    addColect(courseId) {
      this.$Api.course.collectCourse({ courseId: courseId }).then((res) => {
        console.log(res);
        this.$Dialog.toast("收藏成功");
      });
    },

    goPay() {
      let selectOrderList = this.orderList.filter((item) => item.selected == true);
      if (selectOrderList.length == 0) {
        this.$Dialog.toast("请先选择要支付的课程", { type: "error" });
        return;
      }
      this.$Jump.href("/orderConfirm", {
        selectOrderList: JSON.stringify(selectOrderList),
      });
    },

    // 立即购买
    buyNow(info) {
      let selectOrderList = [info];
      this.$Jump.href("/orderConfirm", {
        selectOrderList: JSON.stringify(selectOrderList),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .coupon_content {
    margin: 20px auto;
    box-sizing: border-box;
    width: $pageMainWidth;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .menu_list {
      .cart_text {
        font-weight: bold;
        font-size: 18px;
      }
    }
  }

  .content {
    .order_list {
      .order_top {
        font-size: 16px;
        color: #333333;
        text-align: center;
        line-height: 50px;
        box-sizing: border-box;
        width: 100%;
        font-weight: 600;
        border-bottom: 1px solid rgba(20, 20, 20, 0.1);

        .selected_box {
          width: 30px;
          min-height: 20px;
        }

        .order_info {
          width: 460px;

          .video_img {
            width: 180px;
            height: 112px;
          }

          .selected_box {
            margin-right: 15px;
          }

          .order_name {
            margin-left: 30px;
          }
        }

        .order_img {
          height: 112px;
        }

        .order_empty {
          width: 240px;
          height: auto;
          text-align: left;

          .spec_info {
            font-size: 12px;
            color: #999;
            margin-top: 5px;

            span {
              margin-right: 10px;
            }
          }
        }

        .order_organization {
          width: 150px;
        }

        .order_price {
          width: 100px;
        }

        .order_action {
          width: 110px;
        }
      }

      .order_one {
        font-size: 18px;
        color: #666666;
        font-weight: normal;
        line-height: auto;
        min-height: 154px;
        border-radius: 10px;
        border-bottom: 1px solid rgba(20, 20, 20, 0.1);

        .order_price_value {
          color: #ff6619;

          .price_num {
            font-size: 22px;
          }
        }

        .action_btn {
          width: 103px;
          height: 112px;
          text-align: center;

          .car_btn {
            line-height: normal;
          }

          .buy_btn {
            color: #ff6619;
          }

          .add_btn {
            color: #666666;
          }
        }
      }
    }

    .check_all_box {
      font-size: 16px;
      width: 100%;

      .check_all {
        .selected_box {
          width: 30px;
          min-height: 20px;
          text-align: center;
        }

        .select_all_text {
          color: #666666;
          margin: 0 10px;
        }

        .split_line {
          width: 1px;
          height: 13px;
          background: rgba(36, 35, 36, 0.1);
        }
      }

      .selected_info {
        color: #666666;

        .selected_num_value {
          color: #ff6619;
        }

        .total_price_text {
          margin-left: 30px;
          margin-right: 10px;
        }

        .total_price_value {
          font-size: 22px;
        }
      }
    }

    .btn_pay {
      width: 200px;
      height: 48px;
      background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
      border-radius: 24px;
      text-align: center;
      line-height: 48px;
      color: #ffffff;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .empty_box {
    text-align: center;

    .car_empty_bg_img {
      width: 260px;
      height: 260px;
    }

    .empty_text {
      color: #666;
      margin-top: -60px;
    }

    .btn {
      width: 170px;
      height: 40px;
      background: linear-gradient(90deg, #00dfca, #00dea0);
      border-radius: 6px;
      text-align: center;
      line-height: 40px;
      margin: 20px auto 60px;
      color: #fff;
    }
  }
}
</style>